import { AlertType } from '../types/types'

export const alertIcon = (type: AlertType): string => {
  const icons = {
    warning: 'alert-triangle',
    error: 'x-circle',
    success: 'check',
    info: 'info',
  }
  return icons[type] || 'info'
}
